import React, { useContext, useState } from 'react';

import {
  ReliabilityOption,
  ReliabilityHelp,
  ReliabilityHelpTrigger,
} from '../../pages/reliability-calculator';
import { ReliabilityCalculatorContext } from './Context';

const Step6 = () => {
  const {
    state: { step6 },
    dispatch,
  } = useContext(ReliabilityCalculatorContext);
  const [helpOpen, toggleHelpOpen] = useState(false);

  return (
    <div className="reliabilityCalculator__cell">
      {helpOpen ? (
        <ReliabilityHelp title="Error budgets" toggleHelpOpen={toggleHelpOpen}>
          <p>
            Error budgets describe the difference between a service’s SLO and
            the actual uptime measured.
          </p>
          <p>
            For example, Service A has an availability SLO of 99.999% for the
            month. This means that the service’s error budget is 0.001% downtime
            for the month (25.92 seconds of downtime).
          </p>
          <p>
            If an incident results in more than 5 seconds of downtime, 19% of
            the error budget is "spent."
          </p>
          <p>
            As long as there is budget remaining, normal engineering work can
            continue. If the budget is exceeded, work should shift to additional
            testing, Chaos Engineering, and development to make the system more
            resilient.
          </p>
        </ReliabilityHelp>
      ) : (
        <div className="hero-titleWrapper u-contrast">
          <h1 className="hero-title">
            Have you established{' '}
            <ReliabilityHelpTrigger onClick={() => toggleHelpOpen(!helpOpen)}>
              error budgets
            </ReliabilityHelpTrigger>{' '}
            ?
          </h1>
        </div>
      )}

      <div className="reliabilityCalculator__grid-2">
        <ReliabilityOption
          title="Yes"
          active={step6 === 'yes'}
          onClick={() => {
            dispatch({
              type: 'choice',
              payload: {
                step6: 'yes',
              },
            });
          }}
        />
        <ReliabilityOption
          title="No"
          active={step6 === 'no'}
          onClick={() => {
            dispatch({
              type: 'choice',
              payload: {
                step6: 'no',
              },
            });
          }}
        />
      </div>
    </div>
  );
};

export default Step6;
